import { Component, OnInit } from '@angular/core';
import { TokenStorage } from '../../auth/token.storage';
import { Router } from '@angular/router';
import { StoreUserDetails } from '../../auth/storeuserdetails';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { MessagingService } from '../messaging.service';
import { UsersService } from 'src/app/services/users/users.service';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit {
  showFiller = false;

  notificationList = [];
  notificationCount: number = 0;
  visible = true;
  _subscription;

  username: string;
  searchText: string;
  searchOption: string = "invoicenumber";
  previsearchOption: string;
  options = [];
  filteredOptions: Observable<string[]>;
  allBranches = [];
  allOrders=[]
  constructor(
    private token: TokenStorage,
    private router: Router,
    private userDetails: StoreUserDetails,
    private notificationService: NotificationService,
    messagingService: MessagingService,
    private userService: UsersService,
    private spinner: NgxSpinnerService
  ) {
    this._subscription = messagingService.currentMessage.subscribe(message => {
      if (message) {
        this.notificationList.push(message.data);
        this.notificationCount = this.notificationList.length;
      }
    })
  }
  myControl: FormControl = new FormControl();


  ngOnInit() {
    this.username = this.userDetails.getUser();
    if(!window.sessionStorage.getItem('userBranchNames')){
    this.spinner.show();
    this.userService.getTenantUsers(this.username).subscribe(userdetails => {
      this.spinner.hide();
      console.log("user", userdetails)
      if (userdetails) {

        this.allBranches = userdetails.branchesMapped;
          let branchNames = userdetails.branchesMapped.map(branch => branch.branchName)
          window.sessionStorage.setItem("userBranchNames", JSON.stringify(branchNames));
    }
  },()=>{
    this.spinner.hide();
  })
}
    this.notificationService.getNotifcationByReadState().subscribe(notifications => {
      this.notificationList = notifications;
      this.notificationCount = notifications.length;
    });
  
}

  keyDownFunction(event) {
    if (this.searchOption != this.previsearchOption) {
      if (this.searchOption === 'invoicenumber')
        this.options = this.allOrders.map(invoice => invoice.orderInfo.orderInvoiceNumber);

      else if (this.searchOption === 'customer')
        this.options = this.allOrders.map(customer => customer.receiverName);

      else if (this.searchOption === 'customerphonenumber')
        this.options = this.allOrders.map(customer => customer.receiverPhoneNumber);
     
      else if (this.searchOption === 'invoiceid')
        this.options = this.allOrders.map(invoice => invoice.orderInfo.orderInvoiceID);
    }

    if (event.keyCode == 13) {
      console.log(this.searchOption);
      console.log(this.searchText);
      if (this.searchText != undefined && this.searchText != "") {
        this.router.navigate(['./searchresult', { searchOption: this.searchOption, searchText: this.searchText }]);
      }
    }
    this.previsearchOption = this.searchOption;
  }


  filter(val: string): string[] {
    return this.options.filter(option => option !== null && option.toLowerCase().includes(val.toLowerCase()));
  }
  doLogout() {
    this.userService.logoutUser(this.token.getToken()).subscribe(() => {
      this.token.signOut();
      this.userDetails.removeUser();
      this.router.navigate(['login']);
    }, Error => {
      console.log(Error);
    })
  }

  removeNotification(notification: any) {
    var i = this.notificationList.indexOf(notification);
    this.notificationList.splice(i, 1);
    this.notificationCount = this.notificationList.length;
  }

  markAllRead() {
    let temp = [];
    this.notificationList.forEach(notification => {
      temp.push(notification.notificationId);
    });
    if (temp.length != 0) {
      this.notificationService.markAllRead(temp).subscribe(result => {
        console.log(result);
      }, Error => {
        console.log(Error);
      });
    }
  }
}
